var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar-(2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 8.03082C12.298 8.03082 12 8.33011 12 8.69875L12 14.0426C12 14.4106 11.7013 14.7105 11.3334 14.7105L2 14.7105C1.63196 14.7105 1.33337 14.4106 1.33337 14.0426L1.33337 4.69093C1.33337 4.3229 1.63196 4.02299 2 4.02299L7.33337 4.02299C7.70203 4.02299 8 3.7237 8 3.35506C8 2.9863 7.70203 2.68701 7.33337 2.68701L2 2.68701C0.897339 2.68701 0 3.58611 0 4.69093L0 14.0426C0 15.1474 0.897339 16.0465 2 16.0465L11.3334 16.0465C12.436 16.0465 13.3334 15.1474 13.3334 14.0426L13.3334 8.69875C13.3334 8.32938 13.0353 8.03082 12.6666 8.03082L12.6666 8.03082Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25075 7.42231C6.20412 7.46903 6.17275 7.52847 6.15944 7.59256L5.68813 9.9546C5.66616 10.0641 5.70082 10.177 5.77944 10.2565C5.84279 10.3199 5.92812 10.3539 6.01552 10.3539C6.03676 10.3539 6.05886 10.352 6.08083 10.3473L8.43752 9.8751C8.50283 9.86164 8.56215 9.83033 8.60817 9.78349L13.8828 4.49851L11.5261 2.13733L6.25075 7.42231Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5117 0.504219C14.8618 -0.147077 13.8044 -0.147077 13.155 0.504219L12.2324 1.42863L14.5891 3.78993L15.5117 2.8654C15.8264 2.55082 15.9998 2.1313 15.9998 1.68511C15.9998 1.23893 15.8264 0.81941 15.5117 0.504219L15.5117 0.504219Z",
    id: "Shape",
    fill: "#10B48C",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEdit);
export default __webpack_public_path__ + "static/media/smallEdit.fd10b3a8086e1d8413db2398f29c3248.svg";
export { ForwardRef as ReactComponent };